import { useAnalytics } from 'use-analytics';
import { useEffect } from 'react';
import useAuth from './hooks/useAuth';

const useResetAnalytics = () => {
  const { isLoggedIn } = useAuth();
  const { reset } = useAnalytics();

  useEffect(() => {
    if (!isLoggedIn) reset();
  }, [reset, isLoggedIn]);
};

export default useResetAnalytics;
